import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { getData } from "../../../Services/Services";
import {
  gisCoordinatesData,
  gisStateCoordinates,
  gisBlockCoordinatesData,
} from "../../../Services/EndPoints";
import "./DashboardTheme.css";

// ─── Constants ─────────────────────────────────────────────────────────────────
const GOOGLE_MAPS_API_KEY = "AIzaSyDLzC-FhQmB8JS2H46OW46DNOEboBbrZVg";
// const STATE_ID = 62;

// // ─── Ladakh Search Grid ────────────────────────────────────────────────────────
// const LADAKH_SEARCH_GRID = (() => {
//   const LAT_MIN = 32.5, LAT_MAX = 35.6;
//   const LNG_MIN = 75.5, LNG_MAX = 79.1;
//   const LAT_STEP = 0.72;
//   const LNG_STEP = 0.90;
//   const grid = [];
//   for (let lat = LAT_MIN; lat <= LAT_MAX + 0.01; lat = Math.round((lat + LAT_STEP) * 100) / 100) {
//     for (let lng = LNG_MIN; lng <= LNG_MAX + 0.01; lng = Math.round((lng + LNG_STEP) * 100) / 100) {
//       grid.push({ lat: Math.round(lat * 10000) / 10000, lng: Math.round(lng * 10000) / 10000 });
//     }
//   }
//   return grid;
// })();

const SEARCH_RADIUS_M = 80000;

// ─── Hierarchical Essential Services (Categories → Subcategories) ──────────────
export const SERVICE_CATEGORIES = [
  {
    id: "search_rescue",
    label: "Search & Rescue",
    icon: "🔍",
    color: "#DC2626",
    accentColor: "#FCA5A5",
    bgColor: "rgba(220,38,38,0.08)",
    borderColor: "rgba(220,38,38,0.25)",
    subcategories: [
      { id: "helipad",           label: "Helipads / Landing Zones",    markerEmoji: "🚁", placeType: "airport",              keyword: "helipad helicopter landing zone ladakh" },
      { id: "ndrf_camp",         label: "NDRF / SDRF Camps",           markerEmoji: "🪖", placeType: "point_of_interest",    keyword: "NDRF SDRF camp rescue ladakh" },
      { id: "mountain_rescue",   label: "Mountain Rescue Posts",       markerEmoji: "⛑️", placeType: "point_of_interest",    keyword: "mountain rescue post ladakh" },
      { id: "army_rescue",       label: "Army Search & Rescue Units",  markerEmoji: "🎖️", placeType: "point_of_interest",    keyword: "army rescue unit search ladakh" },
      { id: "rope_bridge",       label: "Rope / Bridge Crossing Points",markerEmoji: "🌉", placeType: "point_of_interest",   keyword: "rope bridge crossing emergency ladakh" },
      { id: "cave_shelter",      label: "Cave / Refuge Shelters",      markerEmoji: "🏔️", placeType: "point_of_interest",   keyword: "cave shelter refuge emergency ladakh" },
      { id: "avalanche_post",    label: "Avalanche Control Posts",     markerEmoji: "🏳️", placeType: "point_of_interest",   keyword: "avalanche control post BRO ladakh" },
      { id: "bro_camp",          label: "BRO Road Camps",              markerEmoji: "🛣️", placeType: "point_of_interest",   keyword: "BRO border roads organisation camp ladakh" },
    ],
  },
  {
    id: "communication",
    label: "Communication & Early Warning",
    icon: "📡",
    color: "#7C3AED",
    accentColor: "#DDD6FE",
    bgColor: "rgba(124,58,237,0.08)",
    borderColor: "rgba(124,58,237,0.25)",
    subcategories: [
      { id: "weather_station",   label: "IMD Weather Stations",        markerEmoji: "🌦️", placeType: "point_of_interest",   keyword: "IMD weather station meteorological ladakh" },
      { id: "flood_sensor",      label: "Flood / Avalanche Sensors",   markerEmoji: "🔔", placeType: "point_of_interest",   keyword: "flood sensor early warning avalanche ladakh" },
      { id: "eoc",               label: "Emergency Operations Centers",markerEmoji: "🏢", placeType: "local_government_office", keyword: "emergency operations center EOC control room ladakh" },
      { id: "satellite_hub",     label: "Satellite Communication Hubs",markerEmoji: "🛰️", placeType: "point_of_interest",   keyword: "satellite communication hub VSAT ladakh" },
      { id: "community_radio",   label: "Community Radio Stations",    markerEmoji: "📻", placeType: "point_of_interest",   keyword: "community radio station AIR ladakh" },
      { id: "siren_tower",       label: "Emergency Siren Towers",      markerEmoji: "🔊", placeType: "point_of_interest",   keyword: "emergency siren alarm tower ladakh" },
      { id: "ham_radio",         label: "HAM Radio / Amateur Stations",markerEmoji: "📡", placeType: "point_of_interest",   keyword: "HAM radio amateur station emergency ladakh" },
    ],
  },
  {
    id: "health",
    label: "Health",
    icon: "🏥",
    color: "#EF4444",
    accentColor: "#FCA5A5",
    bgColor: "rgba(239,68,68,0.08)",
    borderColor: "rgba(239,68,68,0.25)",
    subcategories: [
      { id: "govt_hospital",     label: "Government Hospitals",     markerEmoji: "🏥", placeType: "hospital",  keyword: "government hospital" },
      { id: "pvt_hospital",      label: "Private Hospitals",        markerEmoji: "🏥", placeType: "hospital",  keyword: "private hospital" },
      { id: "phc",               label: "Primary Health Centres",   markerEmoji: "🩺", placeType: "hospital",  keyword: "primary health centre PHC" },
      { id: "clinic",            label: "Clinics",                  markerEmoji: "🏥", placeType: "doctor",    keyword: "clinic" },
      { id: "pharmacy",          label: "Pharmacies / Medical Stores", markerEmoji: "💊", placeType: "pharmacy", keyword: "pharmacy medical store" },
      { id: "blood_bank",        label: "Blood Banks",              markerEmoji: "🩸", placeType: "hospital",  keyword: "blood bank" },
      { id: "ambulance",         label: "Ambulance Services",       markerEmoji: "🚑", placeType: "hospital",  keyword: "ambulance service" },
    ],
  },
  {
    id: "supply_chain",
    label: "Critical Supply Chain",
    icon: "⛽",
    color: "#D97706",
    accentColor: "#FDE68A",
    bgColor: "rgba(217,119,6,0.08)",
    borderColor: "rgba(217,119,6,0.25)",
    subcategories: [
      { id: "fuel_depot",        label: "Fuel Reserves / Emergency Depots", markerEmoji: "⛽", placeType: "gas_station",    keyword: "fuel depot emergency reserve petrol ladakh" },
      { id: "lpg_dist",          label: "LPG Distribution Points",     markerEmoji: "🔵", placeType: "point_of_interest",   keyword: "LPG gas distribution cylinder ladakh" },
      { id: "ration_emergency",  label: "Emergency PDS / Ration Stores",markerEmoji: "🏪", placeType: "store",              keyword: "emergency ration PDS fair price store ladakh" },
      { id: "water_tanker",      label: "Water Tanker Stations",       markerEmoji: "🚰", placeType: "point_of_interest",   keyword: "water tanker supply station ladakh" },
      { id: "medicine_stock",    label: "Emergency Medicine Stockpiles",markerEmoji: "💊", placeType: "pharmacy",           keyword: "emergency medicine stockpile store ladakh" },
      { id: "generator_unit",    label: "Generator / Power Backup Units",markerEmoji:"🔋", placeType: "point_of_interest",  keyword: "generator power backup diesel unit ladakh" },
      { id: "cold_chain",        label: "Cold Chain / Vaccine Storage", markerEmoji: "🧊", placeType: "point_of_interest",  keyword: "cold chain vaccine storage facility ladakh" },
      { id: "supply_warehouse",  label: "Emergency Supply Warehouses", markerEmoji: "🏭", placeType: "point_of_interest",   keyword: "emergency supply warehouse stockpile ladakh" },
    ],
  },
  {
    id: "emergency",
    label: "Emergency & Safety",
    icon: "🚓",
    color: "#F97316",
    accentColor: "#FDBA74",
    bgColor: "rgba(249,115,22,0.08)",
    borderColor: "rgba(249,115,22,0.25)",
    subcategories: [
      { id: "police",            label: "Police Stations",          markerEmoji: "🚔", placeType: "police",                  keyword: "police station" },
      { id: "fire_station",      label: "Fire Stations",            markerEmoji: "🚒", placeType: "fire_station",            keyword: "fire station" },
      { id: "disaster_mgmt",     label: "Disaster Management",      markerEmoji: "🛡️", placeType: "local_government_office", keyword: "disaster management office DDMA" },
      { id: "army_camp",         label: "Army / Border Security",   markerEmoji: "🪖", placeType: "point_of_interest",       keyword: "army camp border security" },
    ],
  },
  {
    id: "government",
    label: "Government Services",
    icon: "🏛",
    color: "#8B5CF6",
    accentColor: "#C4B5FD",
    bgColor: "rgba(139,92,246,0.08)",
    borderColor: "rgba(139,92,246,0.25)",
    subcategories: [
      { id: "collector",         label: "District Collector Office", markerEmoji: "🏛", placeType: "local_government_office", keyword: "district collector office" },
      { id: "municipality",      label: "Municipality Office",      markerEmoji: "🏢", placeType: "local_government_office", keyword: "municipality office nagar palika" },
      { id: "revenue_office",    label: "Revenue Office",           markerEmoji: "📋", placeType: "local_government_office", keyword: "revenue office tehsil" },
      { id: "aadhaar_center",    label: "Aadhaar Centers",          markerEmoji: "🪪", placeType: "point_of_interest",       keyword: "aadhaar enrollment center" },
      { id: "post_office",       label: "Post Offices",             markerEmoji: "📮", placeType: "post_office",             keyword: "post office" },
      { id: "bank_atm",          label: "Banks & ATMs",             markerEmoji: "🏧", placeType: "bank",                    keyword: "bank ATM" },
      { id: "electricity_dept",  label: "Electricity Department",   markerEmoji: "⚡", placeType: "local_government_office", keyword: "electricity department power office" },
      { id: "water_dept",        label: "Water Supply Department",  markerEmoji: "🚰", placeType: "local_government_office", keyword: "water supply department PHE" },
    ],
  },
  {
    id: "transport",
    label: "Transportation",
    icon: "🚌",
    color: "#3B82F6",
    accentColor: "#93C5FD",
    bgColor: "rgba(59,130,246,0.08)",
    borderColor: "rgba(59,130,246,0.25)",
    subcategories: [
      { id: "airport",           label: "Airports",                 markerEmoji: "✈️", placeType: "airport",       keyword: "airport" },
      { id: "bus_stand",         label: "Bus Stands",               markerEmoji: "🚌", placeType: "bus_station",   keyword: "bus stand bus station" },
      { id: "taxi_stand",        label: "Taxi Stands",              markerEmoji: "🚕", placeType: "taxi_stand",    keyword: "taxi stand" },
      { id: "petrol_pump",       label: "Petrol Pumps",             markerEmoji: "⛽", placeType: "gas_station",   keyword: "petrol pump gas station" },
      { id: "ev_charging",       label: "EV Charging Stations",     markerEmoji: "🔌", placeType: "point_of_interest", keyword: "EV charging station electric vehicle" },
      { id: "parking",           label: "Parking Areas",            markerEmoji: "🅿️", placeType: "parking",       keyword: "parking" },
    ],
  },
  {
    id: "natural",
    label: "Natural Resources",
    icon: "🌊",
    color: "#0891B2",
    accentColor: "#67E8F9",
    bgColor: "rgba(8,145,178,0.08)",
    borderColor: "rgba(8,145,178,0.25)",
    subcategories: [
      { id: "river",             label: "Rivers",                   markerEmoji: "🌊", placeType: "natural_feature",     keyword: "river" },
      { id: "lake",              label: "Lakes",                    markerEmoji: "💧", placeType: "natural_feature",     keyword: "lake tso" },
      { id: "dam",               label: "Dams",                     markerEmoji: "🌉", placeType: "point_of_interest",   keyword: "dam reservoir" },
      { id: "glacier",           label: "Glaciers",                 markerEmoji: "🏔️", placeType: "natural_feature",     keyword: "glacier" },
    ],
  },
  {
    id: "infrastructure",
    label: "Infrastructure",
    icon: "⚡",
    color: "#7C3AED",
    accentColor: "#DDD6FE",
    bgColor: "rgba(124,58,237,0.08)",
    borderColor: "rgba(124,58,237,0.25)",
    subcategories: [
      { id: "power_substation",  label: "Power Substations",        markerEmoji: "⚡", placeType: "point_of_interest",   keyword: "power substation electricity grid" },
      { id: "telecom_tower",     label: "Telecom Towers",           markerEmoji: "📡", placeType: "point_of_interest",   keyword: "telecom tower mobile" },
      { id: "internet_center",   label: "Internet Service Centers", markerEmoji: "🌐", placeType: "point_of_interest",   keyword: "internet service center CSC" },
      { id: "water_tank",        label: "Water Tanks",              markerEmoji: "🚰", placeType: "point_of_interest",   keyword: "water tank overhead reservoir" },
      { id: "sewage_plant",      label: "Sewage Plants",            markerEmoji: "🏗️", placeType: "point_of_interest",   keyword: "sewage treatment plant" },
    ],
  },
  {
    id: "land_resources",
    label: "Land & Forest Resources",
    icon: "🌿",
    color: "#65A30D",
    accentColor: "#BEF264",
    bgColor: "rgba(101,163,13,0.08)",
    borderColor: "rgba(101,163,13,0.25)",
    subcategories: [
      { id: "agriculture_land",     label: "Agriculture Land",          markerEmoji: "🌿", placeType: "point_of_interest",   keyword: "agriculture farm agricultural land ladakh" },
      { id: "krishi_kendra",        label: "Krishi Vigyan Kendra",      markerEmoji: "🧑‍🌾", placeType: "point_of_interest",  keyword: "krishi vigyan kendra agriculture center" },
      { id: "horticulture",         label: "Horticulture Centers",      markerEmoji: "🍎", placeType: "point_of_interest",   keyword: "horticulture center nursery ladakh" },
      { id: "irrigation_canal",     label: "Irrigation Canals",         markerEmoji: "💧", placeType: "point_of_interest",   keyword: "irrigation canal water channel ladakh" },
      { id: "cold_storage",         label: "Cold Storage Units",        markerEmoji: "🧊", placeType: "point_of_interest",   keyword: "cold storage unit facility ladakh" },
      { id: "mandi",                label: "Agricultural Mandis",       markerEmoji: "🏪", placeType: "point_of_interest",   keyword: "mandi agricultural market apmc" },
      { id: "forest_area",          label: "Forest Areas",              markerEmoji: "🌲", placeType: "park",                keyword: "forest area reserve forest ladakh" },
      { id: "wildlife_sanctuary",   label: "Wildlife Sanctuaries",      markerEmoji: "🐾", placeType: "park",                keyword: "wildlife sanctuary national park ladakh" },
      { id: "forest_checkpost",     label: "Forest Check Posts",        markerEmoji: "🛖", placeType: "point_of_interest",   keyword: "forest check post range office ladakh" },
      { id: "forest_nursery",       label: "Forest Nurseries",          markerEmoji: "🌱", placeType: "point_of_interest",   keyword: "forest nursery plantation site ladakh" },
      { id: "pasture_land",         label: "Pasture / Grazing Land",    markerEmoji: "🐑", placeType: "point_of_interest",   keyword: "pasture grazing land meadow ladakh" },
      { id: "soil_testing",         label: "Soil Testing Centers",      markerEmoji: "🧪", placeType: "point_of_interest",   keyword: "soil testing center lab agriculture" },
    ],
  },
  {
    id: "relief_rehabilitation",
    label: "Relief & Rehabilitation",
    icon: "🏕️",
    color: "#059669",
    accentColor: "#A7F3D0",
    bgColor: "rgba(5,150,105,0.08)",
    borderColor: "rgba(5,150,105,0.25)",
    subcategories: [
      { id: "relief_camp",       label: "Relief Camps / Shelters",     markerEmoji: "⛺", placeType: "point_of_interest",   keyword: "relief camp temporary shelter disaster ladakh" },
      { id: "food_dist",         label: "Food Distribution Points",    markerEmoji: "🍱", placeType: "point_of_interest",   keyword: "food distribution relief point ladakh" },
      { id: "clothing_dist",     label: "Clothing / Blanket Centers",  markerEmoji: "🧥", placeType: "point_of_interest",   keyword: "clothing blanket distribution relief ladakh" },
      { id: "medical_relief",    label: "Medical Relief Camps",        markerEmoji: "🩺", placeType: "point_of_interest",   keyword: "medical relief camp first aid ladakh" },
      { id: "psych_support",     label: "Psychosocial Support Centers",markerEmoji: "🧠", placeType: "point_of_interest",   keyword: "psychosocial support mental health relief ladakh" },
      { id: "registration",      label: "Displaced Persons Reg. Points",markerEmoji:"📋", placeType: "point_of_interest",   keyword: "displaced persons registration relief ladakh" },
      { id: "community_kitchen", label: "Community Kitchens / Langars",markerEmoji: "🍲", placeType: "point_of_interest",   keyword: "community kitchen langar relief ladakh" },
      { id: "ngo_center",        label: "NGO Relief Centers",          markerEmoji: "🤝", placeType: "point_of_interest",   keyword: "NGO relief center disaster ladakh" },
    ],
  },
  {
    id: "vulnerable_population",
    label: "Vulnerable Population Centers",
    icon: "👥",
    color: "#BE185D",
    accentColor: "#FBCFE8",
    bgColor: "rgba(190,24,93,0.08)",
    borderColor: "rgba(190,24,93,0.25)",
    subcategories: [
      { id: "vp_old_age_home",     label: "Old Age Homes",                  markerEmoji: "🏠", placeType: "point_of_interest",      keyword: "old age home senior citizen center ladakh" },
      { id: "vp_orphanage",        label: "Orphanages / Child Care",        markerEmoji: "🧒", placeType: "point_of_interest",      keyword: "orphanage child care center ladakh" },
      { id: "vp_disability_center",label: "Disability Care Centers",        markerEmoji: "♿", placeType: "point_of_interest",      keyword: "disability care rehabilitation center ladakh" },
      { id: "vp_womens_shelter",   label: "Women & Children Shelters",      markerEmoji: "👩", placeType: "point_of_interest",      keyword: "women shelter protection center ladakh" },
      { id: "vp_anganwadi",        label: "Anganwadi Centers",              markerEmoji: "👶", placeType: "point_of_interest",      keyword: "anganwadi ICDS center ladakh" },
      { id: "vp_tribal_hamlet",    label: "Remote / Tribal Hamlets",        markerEmoji: "🏘️", placeType: "point_of_interest",      keyword: "remote village hamlet tribal settlement ladakh" },
      { id: "vp_nomadic_camp",     label: "Nomadic / Changpa Camps",        markerEmoji: "⛺", placeType: "point_of_interest",      keyword: "nomadic camp changpa pashmina ladakh" },
      { id: "vp_migrant_worker",   label: "Migrant Worker Settlements",     markerEmoji: "👷", placeType: "point_of_interest",      keyword: "migrant worker settlement labour camp ladakh" },
      { id: "vp_high_altitude",    label: "High Altitude Villages (>4000m)",markerEmoji: "🏔️", placeType: "point_of_interest",      keyword: "high altitude village 4000m ladakh" },
      { id: "vp_prison",           label: "Jails / Detention Centers",      markerEmoji: "🔒", placeType: "point_of_interest",      keyword: "jail prison detention center ladakh" },
    ],
  },
  {
    id: "vulnerable_infrastructure",
    label: "Vulnerable Infrastructure",
    icon: "⚠️",
    color: "#DC2626",
    accentColor: "#FCA5A5",
    bgColor: "rgba(220,38,38,0.08)",
    borderColor: "rgba(220,38,38,0.25)",
    subcategories: [
      { id: "vi_bridge",           label: "Critical Bridges",               markerEmoji: "🌉", placeType: "point_of_interest",      keyword: "critical bridge crossing highway ladakh" },
      { id: "vi_tunnel",           label: "Road Tunnels",                   markerEmoji: "🚇", placeType: "point_of_interest",      keyword: "road tunnel highway Z-morh Zoji-la ladakh" },
      { id: "vi_mountain_pass",    label: "Mountain Passes (Seasonal)",     markerEmoji: "🏔️", placeType: "point_of_interest",      keyword: "mountain pass khardung la chang la baralacha ladakh" },
      { id: "vi_landslide_zone",   label: "Landslide Prone Zones",         markerEmoji: "⛰️", placeType: "point_of_interest",      keyword: "landslide prone zone unstable slope ladakh" },
      { id: "vi_flood_zone",       label: "Flash Flood Prone Areas",       markerEmoji: "🌊", placeType: "point_of_interest",      keyword: "flash flood prone zone nullah river ladakh" },
      { id: "vi_avalanche_zone",   label: "Avalanche Prone Corridors",     markerEmoji: "🌨️", placeType: "point_of_interest",      keyword: "avalanche prone corridor zone ladakh" },
      { id: "vi_glof_zone",        label: "GLOF Risk Zones",               markerEmoji: "💧", placeType: "point_of_interest",      keyword: "glacial lake outburst flood GLOF risk zone ladakh" },
      { id: "vi_power_line",       label: "Critical Power Transmission Lines",markerEmoji:"⚡", placeType: "point_of_interest",     keyword: "high voltage power transmission line tower ladakh" },
      { id: "vi_water_source",     label: "Critical Water Sources",        markerEmoji: "🚰", placeType: "point_of_interest",      keyword: "critical water source spring canal intake ladakh" },
      { id: "vi_telecom_backbone", label: "Telecom Backbone Points",       markerEmoji: "📡", placeType: "point_of_interest",      keyword: "telecom backbone OFC cable exchange ladakh" },
      { id: "vi_old_structure",    label: "Structurally Weak Buildings",   markerEmoji: "🏚️", placeType: "point_of_interest",      keyword: "old weak structure building seismic risk ladakh" },
    ],
  },
  {
    id: "border_strategic",
    label: "Border Security & Strategic",
    icon: "🪖",
    color: "#1E3A5F",
    accentColor: "#93C5FD",
    bgColor: "rgba(30,58,95,0.08)",
    borderColor: "rgba(30,58,95,0.25)",
    subcategories: [
      { id: "bs_army_base",        label: "Army Base / Cantonment",         markerEmoji: "🪖", placeType: "point_of_interest",      keyword: "army base cantonment military station ladakh" },
      { id: "bs_itbp_post",        label: "ITBP / Border Posts",            markerEmoji: "🛡️", placeType: "point_of_interest",      keyword: "ITBP border post Indo-Tibetan police ladakh" },
      { id: "bs_bsf_post",         label: "BSF / Paramilitary Posts",       markerEmoji: "🔫", placeType: "point_of_interest",      keyword: "BSF paramilitary post border security ladakh" },
      { id: "bs_lac_buffer",       label: "LAC Buffer / Forward Areas",     markerEmoji: "🗺️", placeType: "point_of_interest",      keyword: "LAC forward area buffer zone patrol ladakh" },
      { id: "bs_strategic_road",   label: "Strategic Roads (BRO)",          markerEmoji: "🛣️", placeType: "point_of_interest",      keyword: "strategic road BRO border roads DBO ladakh" },
      { id: "bs_airbase",          label: "Air Bases / Airstrips",          markerEmoji: "✈️", placeType: "airport",                keyword: "air base airstrip military airport ladakh" },
      { id: "bs_radar_station",    label: "Radar / Surveillance Stations",  markerEmoji: "📡", placeType: "point_of_interest",      keyword: "radar surveillance station IAF ladakh" },
      { id: "bs_fuel_dump",        label: "Strategic Fuel Dumps",           markerEmoji: "⛽", placeType: "point_of_interest",      keyword: "strategic fuel dump depot military ladakh" },
      { id: "bs_field_hospital",   label: "Military Field Hospitals",       markerEmoji: "🏥", placeType: "hospital",               keyword: "military field hospital army medical corps ladakh" },
      { id: "bs_icp",              label: "Integrated Check Posts (ICP)",   markerEmoji: "🚧", placeType: "point_of_interest",      keyword: "integrated check post ICP border crossing ladakh" },
    ],
  },
  {
    id: "temp_emergency_infra",
    label: "Temporary Emergency Infrastructure",
    icon: "🏗️",
    color: "#0369A1",
    accentColor: "#BAE6FD",
    bgColor: "rgba(3,105,161,0.08)",
    borderColor: "rgba(3,105,161,0.25)",
    subcategories: [
      { id: "tei_field_hospital",  label: "Field / Mobile Hospitals",       markerEmoji: "🏥", placeType: "point_of_interest",      keyword: "field hospital mobile medical unit disaster ladakh" },
      { id: "tei_temp_shelter",    label: "Temporary Shelter Camps",        markerEmoji: "⛺", placeType: "point_of_interest",      keyword: "temporary shelter camp tent colony disaster ladakh" },
      { id: "tei_mobile_kitchen",  label: "Mobile Kitchen Units",           markerEmoji: "🍲", placeType: "point_of_interest",      keyword: "mobile kitchen unit langar disaster relief ladakh" },
      { id: "tei_water_purif",     label: "Mobile Water Purification Units",markerEmoji: "💧", placeType: "point_of_interest",      keyword: "mobile water purification unit tanker disaster ladakh" },
      { id: "tei_temp_bridge",     label: "Bailey / Temporary Bridges",     markerEmoji: "🌉", placeType: "point_of_interest",      keyword: "bailey bridge temporary bridge BRO emergency ladakh" },
      { id: "tei_heli_pad",        label: "Temporary Helipads",             markerEmoji: "🚁", placeType: "point_of_interest",      keyword: "temporary helipad landing zone emergency ladakh" },
      { id: "tei_staging_area",    label: "Disaster Staging Areas",         markerEmoji: "🏟️", placeType: "point_of_interest",      keyword: "disaster staging area assembly point relief ladakh" },
      { id: "tei_mobile_tower",    label: "Mobile Telecom Towers (COW)",    markerEmoji: "📶", placeType: "point_of_interest",      keyword: "mobile COW cell on wheels temporary tower disaster ladakh" },
      { id: "tei_generator_camp",  label: "Emergency Power Generator Camps",markerEmoji: "🔋", placeType: "point_of_interest",      keyword: "emergency power generator camp DG set disaster ladakh" },
      { id: "tei_decon_unit",      label: "Decontamination Units",          markerEmoji: "🧪", placeType: "point_of_interest",      keyword: "decontamination unit CBRN hazmat disaster ladakh" },
      { id: "tei_body_mgmt",       label: "Temporary Mortuary / Body Mgmt.",markerEmoji: "🏛️", placeType: "point_of_interest",      keyword: "temporary mortuary body management disaster relief ladakh" },
    ],
  },
  {
    id: "education",
    label: "Education",
    icon: "🎓",
    color: "#10B981",
    accentColor: "#6EE7B7",
    bgColor: "rgba(16,185,129,0.08)",
    borderColor: "rgba(16,185,129,0.25)",
    subcategories: [
      { id: "govt_school",       label: "Government Schools",       markerEmoji: "🏫", placeType: "school",              keyword: "government school" },
      { id: "pvt_school",        label: "Private Schools",          markerEmoji: "🏫", placeType: "school",              keyword: "private school" },
      { id: "college",           label: "Colleges",                 markerEmoji: "🎓", placeType: "university",          keyword: "college university" },
      { id: "hostel",            label: "Hostels",                  markerEmoji: "🏠", placeType: "lodging",             keyword: "student hostel" },
      { id: "skill_center",      label: "Skill Development Centers",markerEmoji: "🛠️", placeType: "point_of_interest",  keyword: "skill development training center ITI" },
    ],
  },
  {
    id: "parks_recreation",
    label: "Public Parks & Recreation",
    icon: "🌳",
    color: "#16A34A",
    accentColor: "#BBF7D0",
    bgColor: "rgba(22,163,74,0.08)",
    borderColor: "rgba(22,163,74,0.25)",
    subcategories: [
      { id: "public_park",       label: "Public Parks",             markerEmoji: "🌳", placeType: "park",                keyword: "public park garden" },
      { id: "children_park",     label: "Children's Parks",         markerEmoji: "🎠", placeType: "park",                keyword: "children park playground" },
      { id: "garden",            label: "Gardens",                  markerEmoji: "🌷", placeType: "park",                keyword: "garden botanical" },
      { id: "picnic_spot",       label: "Picnic Spots",             markerEmoji: "🧺", placeType: "park",                keyword: "picnic spot" },
      { id: "sports_ground",     label: "Sports Grounds / Stadiums",markerEmoji: "🏟️", placeType: "stadium",             keyword: "sports ground stadium" },
      { id: "walking_track",     label: "Walking Tracks",           markerEmoji: "🚶", placeType: "park",                keyword: "walking track jogging trail" },
    ],
  },
];

// ─── Build flat lookup from categories ─────────────────────────────────────────
export const ALL_SUBCATEGORIES = {};
SERVICE_CATEGORIES.forEach(cat => {
  cat.subcategories.forEach(sub => {
    ALL_SUBCATEGORIES[sub.id] = {
      ...sub,
      parentId: cat.id,
      parentColor: cat.color,
      parentAccent: cat.accentColor,
    };
  });
});

// ─── Per-category animation config ────────────────────────────────────────────
export const CATEGORY_ANIM_CONFIG = {
  health:                     { anim: "smBounce",   duration: "2.2s", pulseColor: "#FFFFFF", shadowColor: "rgba(239,68,68,0.8)",    bgColor: "linear-gradient(145deg,#FFFFFF,#FFFFFF)",   border: "1.5px solid #FF6B6B",   size: 30 },
  emergency:                  { anim: "smSpin",     duration: "3.0s", pulseColor: "#FF6B00", shadowColor: "rgba(249,115,22,0.8)",   bgColor: "linear-gradient(145deg,#F97316,#C2410C)",   border: "1.5px solid #FDBA74",   size: 30 },
  transport:                  { anim: "smFloatUp",  duration: "2.6s", pulseColor: "#3B82F6", shadowColor: "rgba(59,130,246,0.8)",   bgColor: "linear-gradient(145deg,#3B82F6,#1D4ED8)",   border: "1.5px solid #93C5FD",   size: 28 },
  government:                 { anim: "smBounce",   duration: "2.8s", pulseColor: "#8B5CF6", shadowColor: "rgba(139,92,246,0.8)",   bgColor: "linear-gradient(145deg,#8B5CF6,#6D28D9)",   border: "1.5px solid #C4B5FD",   size: 28 },
  education:                  { anim: "smFloatUp",  duration: "2.4s", pulseColor: "#10B981", shadowColor: "rgba(16,185,129,0.8)",   bgColor: "linear-gradient(145deg,#10B981,#047857)",   border: "1.5px solid #6EE7B7",   size: 28 },
  natural:                    { anim: "smFloatUp",  duration: "3.2s", pulseColor: "#06B6D4", shadowColor: "rgba(6,182,212,0.8)",    bgColor: "linear-gradient(145deg,#0891B2,#164E63)",   border: "1.5px solid #67E8F9",   size: 28 },
  infrastructure:             { anim: "smGlow",     duration: "2.0s", pulseColor: "#A855F7", shadowColor: "rgba(168,85,247,0.8)",   bgColor: "linear-gradient(145deg,#7C3AED,#4C1D95)",   border: "1.5px solid #D8B4FE",   size: 28 },
  land_resources:             { anim: "smFloatUp",  duration: "2.8s", pulseColor: "#84CC16", shadowColor: "rgba(132,204,22,0.8)",   bgColor: "linear-gradient(145deg,#65A30D,#3F6212)",   border: "1.5px solid #BEF264",   size: 28 },
  search_rescue:              { anim: "smSpin",     duration: "1.8s", pulseColor: "#FF2222", shadowColor: "rgba(220,38,38,0.95)",   bgColor: "linear-gradient(145deg,#DC2626,#7F1D1D)",   border: "1.5px solid #FF4444",   size: 34 },
  communication:              { anim: "smGlow",     duration: "1.6s", pulseColor: "#A78BFA", shadowColor: "rgba(124,58,237,0.9)",   bgColor: "linear-gradient(145deg,#6D28D9,#3B0764)",   border: "1.5px solid #C4B5FD",   size: 30 },
  relief_rehabilitation:      { anim: "smBounce",   duration: "2.2s", pulseColor: "#34D399", shadowColor: "rgba(5,150,105,0.8)",    bgColor: "linear-gradient(145deg,#059669,#064E3B)",   border: "1.5px solid #6EE7B7",   size: 30 },
  supply_chain:               { anim: "smFloatUp",  duration: "2.4s", pulseColor: "#FCD34D", shadowColor: "rgba(217,119,6,0.8)",    bgColor: "linear-gradient(145deg,#D97706,#92400E)",   border: "1.5px solid #FDE68A",   size: 30 },
  vulnerable_population:      { anim: "smBounce",   duration: "2.4s", pulseColor: "#F472B6", shadowColor: "rgba(190,24,93,0.85)",   bgColor: "linear-gradient(145deg,#BE185D,#831843)",   border: "1.5px solid #FBCFE8",   size: 30 },
  vulnerable_infrastructure:  { anim: "smSpin",     duration: "2.0s", pulseColor: "#FF4444", shadowColor: "rgba(220,38,38,0.9)",    bgColor: "linear-gradient(145deg,#DC2626,#7F1D1D)",   border: "1.5px solid #FCA5A5",   size: 32 },
  border_strategic:           { anim: "smGlow",     duration: "1.8s", pulseColor: "#60A5FA", shadowColor: "rgba(30,64,175,0.9)",    bgColor: "linear-gradient(145deg,#1E40AF,#0F172A)",   border: "1.5px solid #93C5FD",   size: 32 },
  temp_emergency_infra:       { anim: "smFloatUp",  duration: "2.2s", pulseColor: "#38BDF8", shadowColor: "rgba(3,105,161,0.85)",   bgColor: "linear-gradient(145deg,#0369A1,#0C4A6E)",   border: "1.5px solid #7DD3FC",   size: 30 },
  tourist_attractions:        { anim: "smBounce",   duration: "2.6s", pulseColor: "#FF6B6B", shadowColor: "rgba(220,38,38,0.8)",    bgColor: "linear-gradient(145deg,#DC2626,#991B1B)",   border: "1.5px solid #FCA5A5",   size: 30 },
  tourism_support:            { anim: "smFloatUp",  duration: "2.4s", pulseColor: "#F472B6", shadowColor: "rgba(190,24,93,0.8)",    bgColor: "linear-gradient(145deg,#BE185D,#831843)",   border: "1.5px solid #FBCFE8",   size: 28 },
  parks_recreation:           { anim: "smFloatUp",  duration: "2.8s", pulseColor: "#4ADE80", shadowColor: "rgba(22,163,74,0.8)",    bgColor: "linear-gradient(145deg,#16A34A,#14532D)",   border: "1.5px solid #86EFAC",   size: 28 },
};

export const DEFAULT_ANIM_CONFIG = {
  anim: "smFloatUp", duration: "2.6s", pulseColor: "#94A3B8",
  shadowColor: "rgba(107,114,128,0.75)",
  bgColor: "linear-gradient(145deg,#475569,#1E293B)",
  border: "2px solid #94A3B8", size: 28,
};

// ─── Places Search Helpers ─────────────────────────────────────────────────────
const _searchPlacesFromCenterPaginated = (mapRef, center, sub) =>
  new Promise(resolve => {
    if (!window.google || !mapRef) { resolve([]); return; }
    const ps = new window.google.maps.places.PlacesService(mapRef);
    const allResults = [];
    const fetchPage = (request, pageToken) => {
      const req = pageToken ? { ...request, pageToken } : request;
      ps.nearbySearch(req, (results, status, pagination) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK ||
          status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS
        ) {
          (results || []).forEach(p => {
            allResults.push({
              id: p.place_id,
              name: p.name,
              lat: p.geometry.location.lat(),
              lng: p.geometry.location.lng(),
              vicinity: p.vicinity,
              rating: p.rating,
              openNow: p.opening_hours?.open_now,
            });
          });
          if (pagination && pagination.hasNextPage && allResults.length < 60) {
            setTimeout(() => pagination.nextPage(), 300);
          } else {
            resolve(allResults);
          }
        } else {
          resolve(allResults);
        }
      });
    };
    // Clean up hardcoded Ladakh-specific keywords so searches work in any state
    const cleanKeyword = sub.keyword
      .replace(/\b(?:ladakh|Z-morh|Zoji-la|khardung la|chang la|baralacha|changpa|pashmina)\b/gi, "")
      .replace(/\s+/g, " ")
      .trim();

    fetchPage({
      location: { lat: center.lat, lng: center.lng },
      radius: SEARCH_RADIUS_M,
      type: sub.placeType,
      keyword: cleanKeyword,
    });
  });

const _pointInRing = (lat, lng, ring) => {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    const intersect =
      yi > lat !== yj > lat &&
      lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

// Caches bounding box on the geometry object to fast-reject points
const getGeometryBounds = (geometry) => {
  if (geometry._bounds) return geometry._bounds;
  let latMin = 90, latMax = -90, lngMin = 180, lngMax = -180;
  const proc = (ring) => {
    for (let i = 0; i < ring.length; i++) {
      const [lng, lat] = ring[i];
      if (lng < lngMin) lngMin = lng;
      if (lng > lngMax) lngMax = lng;
      if (lat < latMin) latMin = lat;
      if (lat > latMax) latMax = lat;
    }
  };
  if (geometry.type === "Polygon") {
    proc(geometry.coordinates[0]);
  } else if (geometry.type === "MultiPolygon") {
    for (let i = 0; i < geometry.coordinates.length; i++) {
      proc(geometry.coordinates[i][0]);
    }
  }
  geometry._bounds = { latMin, latMax, lngMin, lngMax };
  return geometry._bounds;
};

const isPointInGeoJSONGeometry = (lat, lng, geometry) => {
  if (!geometry) return false;

  const bounds = getGeometryBounds(geometry);
  if (lat < bounds.latMin || lat > bounds.latMax || lng < bounds.lngMin || lng > bounds.lngMax) {
    return false;
  }

  if (geometry.type === "Polygon") {
    const [outer, ...holes] = geometry.coordinates;
    if (!_pointInRing(lat, lng, outer)) return false;
    for (const hole of holes) {
      if (_pointInRing(lat, lng, hole)) return false;
    }
    return true;
  }
  if (geometry.type === "MultiPolygon") {
    return geometry.coordinates.some(poly => {
      const [outer, ...holes] = poly;
      if (!_pointInRing(lat, lng, outer)) return false;
      for (const hole of holes) {
        if (_pointInRing(lat, lng, hole)) return false;
      }
      return true;
    });
  }
  return false;
};

const isPointInGeoJSON = (lat, lng, geojson) => {
  if (!geojson) return false;
  if (geojson.type === "Feature") return isPointInGeoJSONGeometry(lat, lng, geojson.geometry);
  if (geojson.type === "FeatureCollection") return geojson.features.some(f => isPointInGeoJSONGeometry(lat, lng, f.geometry));
  return isPointInGeoJSONGeometry(lat, lng, geojson);
};

// ─── Generate search grid from any GeoJSON boundary ──────────────────────────
const generateSearchGrid = (geojson, step = 0.72) => {
  if (!geojson) return [];
  const bounds = { latMin: 90, latMax: -90, lngMin: 180, lngMax: -180 };
  const processCoords = (coords) => {
    if (!Array.isArray(coords)) return;
    if (typeof coords[0] === "number") {
      bounds.lngMin = Math.min(bounds.lngMin, coords[0]);
      bounds.lngMax = Math.max(bounds.lngMax, coords[0]);
      bounds.latMin = Math.min(bounds.latMin, coords[1]);
      bounds.latMax = Math.max(bounds.latMax, coords[1]);
    } else {
      coords.forEach(processCoords);
    }
  };
  const extractGeom = (obj) => {
    if (!obj) return;
    if (obj.type === "FeatureCollection") obj.features.forEach(extractGeom);
    else if (obj.type === "Feature") { if (obj.geometry?.coordinates) processCoords(obj.geometry.coordinates); }
    else if (obj.coordinates) processCoords(obj.coordinates);
  };
  extractGeom(geojson);

  const grid = [];
  for (let lat = bounds.latMin; lat <= bounds.latMax + 0.01; lat = Math.round((lat + step) * 100) / 100) {
    for (let lng = bounds.lngMin; lng <= bounds.lngMax + 0.01; lng = Math.round((lng + step * 1.25) * 100) / 100) {
      grid.push({ lat: Math.round(lat * 10000) / 10000, lng: Math.round(lng * 10000) / 10000 });
    }
  }
  return grid;
};

export const fetchPlacesAcrossState = async (mapRef, sub, stateGeoJSON) => {
  if (!window.google || !mapRef) return [];

  // Dynamic grid from the boundary instead of hardcoded coordinates
  const searchGrid = generateSearchGrid(stateGeoJSON);
  if (searchGrid.length === 0) return [];

  const BATCH_SIZE = 4;
  const BATCH_DELAY = 400;
  const allPlaces = [];
  const seen = new Set();
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  for (let i = 0; i < searchGrid.length; i += BATCH_SIZE) {
    const batch = searchGrid.slice(i, i + BATCH_SIZE);
    const batchResults = await Promise.all(
      batch.map(center => _searchPlacesFromCenterPaginated(mapRef, center, sub))
    );
    batchResults.flat().forEach(place => {
      if (seen.has(place.id)) return;
      seen.add(place.id);
      if (stateGeoJSON && !isPointInGeoJSON(place.lat, place.lng, stateGeoJSON)) return;
      allPlaces.push(place);
    });
    if (i + BATCH_SIZE < searchGrid.length) await sleep(BATCH_DELAY);
  }
  return allPlaces;
};

// ─── EssentialServicesPanel Component ─────────────────────────────────────────
/**
 * EssentialServicesPanel
 *
 * Props:
 *   expandedCategories    {string[]}   - category IDs currently expanded
 *   onToggleCategory      {Function}   - (catId) => void
 *   enabledSubcategories  {string[]}   - subcategory IDs currently active
 *   onToggleSubcategory   {Function}   - (subId, parentCat) => void
 *   subcategoryCounts     {Object}     - { [subId]: number }
 *   loadingSubcategories  {string[]}   - subcategory IDs being fetched
 */
const EssentialServicesPanel = ({
  expandedCategories,
  onToggleCategory,
  enabledSubcategories,
  onToggleSubcategory,
  subcategoryCounts,
  loadingSubcategories,
}) => {
  const [searchTerm, setSearchTerm]   = useState("");
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const bodyRef = useRef(null);

  // Animate height on open/close
  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    if (isPanelOpen) {
      el.style.overflow = "hidden";
      el.style.height   = "0px";
      el.style.opacity  = "0";
      const nat = el.scrollHeight || 420;
      requestAnimationFrame(() => {
        el.style.height  = nat + "px";
        el.style.opacity = "1";
      });
      const t = setTimeout(() => {
        el.style.height   = "auto";
        el.style.overflow = "";
      }, 380);
      return () => clearTimeout(t);
    } else {
      const cur = el.scrollHeight;
      el.style.overflow = "hidden";
      el.style.height   = cur + "px";
      el.style.opacity  = "1";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.height  = "0px";
          el.style.opacity = "0";
        });
      });
    }
  }, [isPanelOpen]);

  const filteredCategories = useMemo(() => {
    if (!searchTerm.trim()) return SERVICE_CATEGORIES;
    const q = searchTerm.toLowerCase();
    return SERVICE_CATEGORIES.map(cat => {
      const matchCat  = cat.label.toLowerCase().includes(q);
      const matchSubs = cat.subcategories.filter(s => s.label.toLowerCase().includes(q));
      if (matchCat) return cat;
      if (matchSubs.length > 0) return { ...cat, subcategories: matchSubs };
      return null;
    }).filter(Boolean);
  }, [searchTerm]);

  const totalEnabled  = enabledSubcategories.length;

  return (
    <>
      <style>{`
        @keyframes esSpin     { to { transform: rotate(360deg) } }
        @keyframes esBadgePop { 0%{transform:scale(0.7);opacity:0} 60%{transform:scale(1.2);opacity:1} 100%{transform:scale(1);opacity:1} }
        @keyframes esSubIn    { from{opacity:0;transform:translateX(-6px)} to{opacity:1;transform:translateX(0)} }
        @keyframes esPanelIn  { from{opacity:0;transform:translateY(-4px)} to{opacity:1;transform:translateY(0)} }

        .es-body {
          transition: height 0.35s cubic-bezier(0.4,0,0.2,1),
                      opacity 0.3s ease;
        }
        .es-chevron-icon {
          transition: transform 0.35s cubic-bezier(0.4,0,0.2,1);
        }
        .es-chevron-icon.open  { transform: rotate(180deg); }
        .es-chevron-icon.closed{ transform: rotate(0deg); }

        .es-cat-card {
          transition: background 0.16s, border-color 0.16s, box-shadow 0.16s, transform 0.12s;
        }
        .es-cat-card:hover  { transform: translateY(-1px); }
        .es-cat-card:active { transform: scale(0.98); }

        .es-subrow        { animation: esSubIn   0.2s ease both; }
        .es-cat-expanded  { animation: esPanelIn 0.22s ease both; }
        .es-badge-pop     { animation: esBadgePop 0.28s ease both; }
      `}</style>

      <div style={{
        background: "var(--od-card-bg)",
        border: "1px solid var(--od-border)",
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        marginTop: 6,
        overflow: "hidden",
      }}>

        {/* ══ HEADER ══ */}
        <div
          onClick={() => setIsPanelOpen(p => !p)}
          style={{
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          background: "var(--od-surface-alt)",
          borderBottom: isPanelOpen ? "1px solid var(--od-border)" : "1px solid transparent",
          borderRadius: "12px 12px 0 0",
          transition: "border-color 0.35s ease",
          minHeight: 52,
          cursor: "pointer",
          userSelect: "none",
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8, flexShrink: 0,
            background: "rgba(59, 130, 246, 0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 16, boxShadow: "0 2px 8px rgba(99,102,241,0.3)",
          }}>🏢</div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "var(--od-text-primary)", letterSpacing: "0.04em" }}>
              Essential Services
            </div>
            <div style={{ fontSize: 11, color: "var(--od-text-muted)" }}>
              {SERVICE_CATEGORIES.length} categories · {totalEnabled > 0 ? `${totalEnabled} active` : "Click to explore"}
            </div>
          </div>

          <div style={{
            display: "flex", alignItems: "center", gap: 4,
            padding: "3px 10px", borderRadius: 20, flexShrink: 0,
            background: totalEnabled > 0 ? "rgba(59,130,246,0.1)" : "transparent",
            border: `1px solid ${totalEnabled > 0 ? "rgba(59,130,246,0.3)" : "transparent"}`,
            fontSize: 11, fontWeight: 700, color: "#3b82f6",
            minWidth: 52, justifyContent: "center",
            transition: "background 0.2s, border-color 0.2s",
          }}>
            {totalEnabled > 0 && <><span>✓</span> {totalEnabled}</>}
          </div>

          <div
            style={{ position: "relative", width: 160, flexShrink: 0 }}
            onClick={e => e.stopPropagation()}
          >
            <input
              type="text"
              placeholder="Search services…"
              value={searchTerm}
              onChange={e => {
                setSearchTerm(e.target.value);
                if (!isPanelOpen && e.target.value) setIsPanelOpen(true);
              }}
              style={{
                width: "100%", padding: "5px 8px 5px 26px",
                border: "1px solid var(--od-border)", borderRadius: 6,
                fontSize: 11, outline: "none",
                background: "var(--od-surface-alt)", color: "var(--od-text-secondary)",
                boxSizing: "border-box", transition: "border-color 0.15s",
              }}
              onFocus={e => e.target.style.borderColor = "#3b82f6"}
              onBlur={e => e.target.style.borderColor = "var(--od-border)"}
            />
            <span style={{ position:"absolute", left:7, top:"50%", transform:"translateY(-50%)", fontSize:12, color:"var(--od-text-muted)", pointerEvents:"none" }}>🔍</span>
            {searchTerm && (
              <span onClick={() => setSearchTerm("")} style={{ position:"absolute", right:7, top:"50%", transform:"translateY(-50%)", fontSize:12, color:"var(--od-text-muted)", cursor:"pointer" }}>✕</span>
            )}
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); setIsPanelOpen(p => !p); }}
            style={{
              width: 30, height: 30, borderRadius: 7, flexShrink: 0,
              background: isPanelOpen ? "rgba(59,130,246,0.08)" : "rgba(99,102,241,0.08)",
              border: `1px solid ${isPanelOpen ? "rgba(59,130,246,0.22)" : "rgba(99,102,241,0.22)"}`,
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
              transition: "background 0.2s, border-color 0.2s",
              padding: 0,
            }}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(99,102,241,0.15)"}
            onMouseLeave={e => e.currentTarget.style.background = isPanelOpen ? "rgba(59,130,246,0.08)" : "rgba(99,102,241,0.08)"}
          >
            <svg
              className={`es-chevron-icon ${isPanelOpen ? "open" : "closed"}`}
              width="12" height="12" viewBox="0 0 12 12" fill="none"
            >
              <path d="M2 4.5L6 8.5L10 4.5" stroke={isPanelOpen ? "#3b82f6" : "#6366f1"}
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* ══ COLLAPSIBLE BODY ══ */}
        <div
          ref={bodyRef}
          className="es-body"
          style={{ height: 0, opacity: 0, overflow: "hidden" }}
        >
          <div style={{
            maxHeight: 420, overflowY: "auto", padding: "8px 12px 10px",
            scrollbarWidth: "thin", scrollbarColor: "#d1d5db transparent",
          }}>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(195px, 1fr))",
              gap: "5px 6px", marginBottom: 10,
            }}>
              {filteredCategories.map((cat) => {
                const isExp    = expandedCategories.includes(cat.id) || !!searchTerm.trim();
                const actCount = cat.subcategories.filter(s => enabledSubcategories.includes(s.id)).length;
                return (
                  <div
                    key={cat.id}
                    className="es-cat-card"
                    onClick={() => onToggleCategory(cat.id)}
                    style={{
                      display:"flex", alignItems:"flex-start", gap:7,
                      padding:"7px 10px", borderRadius:8, cursor:"pointer", userSelect:"none",
                      border: isExp ? `1.5px solid ${cat.color}` : actCount > 0 ? `1px solid ${cat.borderColor}` : "1px solid var(--od-border)",
                      background: isExp ? `${cat.color}12` : actCount > 0 ? cat.bgColor : "var(--od-surface-alt)",
                      boxShadow: isExp ? `0 0 0 2px ${cat.color}18` : "none",
                    }}
                  >
                    <div style={{
                      width:18, height:18, borderRadius:5, flexShrink:0, marginTop:1,
                      border:`1.5px solid ${isExp ? cat.color : "var(--od-border)"}`,
                      background: isExp ? cat.color : "transparent",
                      display:"flex", alignItems:"center", justifyContent:"center",
                      transition:"all 0.2s",
                    }}>
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                        style={{ transform: isExp ? "rotate(180deg)" : "rotate(0deg)", transition:"transform 0.25s cubic-bezier(0.4,0,0.2,1)" }}>
                        <path d="M1 3L4 6L7 3" stroke={isExp ? "#fff" : "var(--od-text-muted)"} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span style={{ fontSize:15, flexShrink:0, marginTop:1 }}>{cat.icon}</span>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:13, fontWeight:500, color: isExp ? cat.color : actCount > 0 ? cat.color : "var(--od-text-secondary)", lineHeight:1.3, wordBreak:"break-word", transition:"color 0.2s" }}>{cat.label}</div>
                      <div style={{ fontSize:12, color:"var(--od-text-muted)" }}>{cat.subcategories.length} services</div>
                    </div>
                    {actCount > 0 && (
                      <span className="es-badge-pop" style={{ fontSize:11, fontWeight:700, color:"#fff", background:cat.color, padding:"2px 6px", borderRadius:20, minWidth:18, textAlign:"center", flexShrink:0, alignSelf:"flex-start", marginTop:1 }}>
                        {actCount}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            {filteredCategories
              .filter(cat => expandedCategories.includes(cat.id) || !!searchTerm.trim())
              .map(cat => {
                const catActiveCount = cat.subcategories.filter(s => enabledSubcategories.includes(s.id)).length;
                const selectAllInCategory = () => {
                  cat.subcategories.forEach(sub => {
                    if (!enabledSubcategories.includes(sub.id)) onToggleSubcategory(sub.id, cat);
                  });
                };
                const clearAllInCategory = () => {
                  cat.subcategories.forEach(sub => {
                    if (enabledSubcategories.includes(sub.id)) onToggleSubcategory(sub.id, cat);
                  });
                };
                return (
                <div key={`exp-${cat.id}`} className="es-cat-expanded" style={{ marginBottom:6, borderRadius:10, border:`1px solid ${cat.borderColor||"var(--od-border)"}`, background:`${cat.color}06`, overflow:"hidden" }}>
                  <div style={{ padding:"6px 12px", borderBottom:`1px solid ${cat.borderColor||"var(--od-border)"}`, display:"flex", alignItems:"center", gap:6, background:`${cat.color}0e` }}>
                    <span style={{ fontSize:13 }}>{cat.icon}</span>
                    <span style={{ fontSize:11, fontWeight:700, color:cat.color }}>{cat.label}</span>
                    <span style={{ fontSize:10, color:"var(--od-text-muted)", marginLeft:"auto" }}>
                      {catActiveCount}/{cat.subcategories.length} selected
                    </span>
                    <button
                      onClick={(e) => { e.stopPropagation(); selectAllInCategory(); }}
                      disabled={catActiveCount === cat.subcategories.length}
                      style={{
                        fontSize: 10, fontWeight: 700, color: catActiveCount === cat.subcategories.length ? "#c7d2fe" : "#3b82f6",
                        background: "transparent", border: "none",
                        cursor: catActiveCount === cat.subcategories.length ? "default" : "pointer", padding: "2px 4px",
                      }}
                    >
                      Select All
                    </button>
                    <span style={{ color: "var(--od-border)", fontSize: 10 }}>|</span>
                    <button
                      onClick={(e) => { e.stopPropagation(); clearAllInCategory(); }}
                      disabled={catActiveCount === 0}
                      style={{
                        fontSize: 10, fontWeight: 700, color: catActiveCount === 0 ? "#fecaca" : "#ef4444",
                        background: "transparent", border: "none",
                        cursor: catActiveCount === 0 ? "default" : "pointer", padding: "2px 4px",
                      }}
                    >
                      Clear All
                    </button>
                  </div>
                  <div style={{ padding:"6px 10px 8px", display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(165px, 1fr))", gap:"3px 6px" }}>
                    {cat.subcategories.map((sub, si) => {
                      const isEn  = enabledSubcategories.includes(sub.id);
                      const isLd  = loadingSubcategories.includes(sub.id);
                      const count = subcategoryCounts[sub.id];
                      return (
                        <div key={sub.id} className="es-subrow" onClick={() => onToggleSubcategory(sub.id, cat)}
                          style={{ display:"flex", alignItems:"center", gap:6, padding:"5px 8px", cursor:"pointer", borderRadius:6, userSelect:"none", animationDelay:`${si*0.02}s`,
                            background: isEn ? `${cat.color}12` : "transparent",
                            border: isEn ? `1px solid ${cat.color}35` : "1px solid transparent",
                            transition:"background 0.14s, border-color 0.14s",
                          }}
                          onMouseEnter={e => { if (!isEn) e.currentTarget.style.background = "var(--od-surface-alt)"; }}
                          onMouseLeave={e => { if (!isEn) e.currentTarget.style.background = "transparent"; }}
                        >
                          <div style={{ width:14, height:14, borderRadius:3, flexShrink:0, border:`1.5px solid ${isEn ? cat.color : "var(--od-border)"}`, background: isEn ? cat.color : "transparent", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.16s" }}>
                            {isEn && <svg width="8" height="6" viewBox="0 0 9 7" fill="none"><path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                          </div>
                          <span style={{ fontSize:12, flexShrink:0 }}>{sub.markerEmoji}</span>
                          <span style={{ fontSize:13, fontWeight: isEn ? 600 : 500, color: isEn ? cat.color : "var(--od-text-secondary)", flex:1, lineHeight:1.2, wordBreak:"break-word", transition:"color 0.14s" }}>{sub.label}</span>
                          {isEn && (
                            <span style={{ fontSize:9, fontWeight:700, color:cat.color, background:`${cat.color}18`, border:`1px solid ${cat.color}35`, padding:"1px 5px", borderRadius:10, minWidth:18, textAlign:"center", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center" }}>
                              {isLd
                                ? <div style={{ width:7, height:7, borderRadius:"50%", border:`1.5px solid ${cat.color}`, borderTopColor:"transparent", animation:"esSpin 0.7s linear infinite" }}/>
                                : (count !== undefined ? count : "—")}
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                );
              })}

            {filteredCategories.length === 0 && (
              <div style={{ textAlign:"center", padding:"20px 0", color:"var(--od-text-muted)", fontSize:12 }}>
                No services matching "{searchTerm}"
              </div>
            )}
          </div>
        </div>

        {/* Collapsed active-services summary strip */}
        {!isPanelOpen && totalEnabled > 0 && (
          <div style={{ padding:"6px 14px", display:"flex", alignItems:"center", gap:6, borderTop:"1px solid var(--od-border)", background:"var(--od-surface-alt)", flexWrap:"wrap", animation:"esPanelIn 0.2s ease" }}>
            <span style={{ fontSize:11, color:"var(--od-text-muted)", fontWeight:600, flexShrink:0 }}>Active:</span>
            {SERVICE_CATEGORIES.filter(cat => cat.subcategories.some(s => enabledSubcategories.includes(s.id))).map(cat => {
              const n = cat.subcategories.filter(s => enabledSubcategories.includes(s.id)).length;
              return (
                <span key={cat.id} style={{ display:"inline-flex", alignItems:"center", gap:3, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, color:cat.color, background:`${cat.color}12`, border:`1px solid ${cat.color}30` }}>
                  {cat.icon} {n}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default EssentialServicesPanel;

